import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    maxWidth: "100%",
  },
  summaryHeader: {
    display: "flex",
    alignItems: "center",
  },
  headerPart: {
    fontSize: "12px",
    marginRight: "16px",
    marginLeft: "2px"
  },
  smallIcon: {
    width: "12px",
    height: "12px"
  },
  documentName: {
    fontSize: "28px",
    fontWeight: 600,
    fontFamily: "Inter",
    position: "relative",
    top: "-2px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineClamp: 1,
    wordBreak: "break-word",
    color: theme.palette.primary.primary800,
  },
}));

export default useStyles;
